/**
 * Registro do Service Worker — PWA Lorentz Webphone.
 */
export function registerPwa() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then(reg => {
        console.log('[PWA] service worker registrado', reg.scope);
      })
      .catch(err => {
        console.warn('[PWA] falha ao registrar SW', err);
      });
  });
}

let deferredPrompt = null;

export function initInstallPrompt(onAvailable) {
  if (typeof window === 'undefined') return () => {};

  const handler = ev => {
    ev.preventDefault();
    deferredPrompt = ev;
    onAvailable?.(true);
  };

  window.addEventListener('beforeinstallprompt', handler);
  return () => window.removeEventListener('beforeinstallprompt', handler);
}

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return outcome === 'accepted';
}
